export const QUERY_KEY_NAME_PAGE = 'page';
export const QUERY_KEY_NAME_SORT_DIR = 'sort_dir';
export const QUERY_KEY_NAME_SORT = 'sort';
export const QUERY_KEY_SRSLTID = 'srsltid';
export const QUERY_KEY_GCID = 'gcid';
export const QUERY_KEY_ACTIVE_TAB = 'activeTab';

/** Query params used by page UI (e.g. Contentful tabs), not product filters. */
export const ROUTE_ONLY_QUERY_KEYS = new Set<string>([QUERY_KEY_ACTIVE_TAB]);

/** Exact ad-click / campaign params that are never Magento facets. */
const TRACKING_QUERY_KEYS = new Set<string>([
  QUERY_KEY_SRSLTID,
  QUERY_KEY_GCID,
  'gclid',
  'gclsrc',
  'dclid',
  'wbraid',
  'gbraid',
  'fbclid',
  'msclkid'
]);

/** Tracking / campaign noise — never a Magento facet. */
export function isTrackingQueryKey(key: string): boolean {
  return (
    TRACKING_QUERY_KEYS.has(key) ||
    key.startsWith('utm_') ||
    key.startsWith('_')
  );
}

export const PRODUCT_LIST_VIEW_KEY = 'product-list-view';
